/** Offset for fixed navbar when scrolling to #section ids */
export const NAVBAR_SCROLL_OFFSET = 124;

export function scrollToSectionById(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_SCROLL_OFFSET;
  window.scrollTo({ top, behavior: 'smooth' });
}

/**
 * Go to a section on the home page (scroll if already on /, else navigate then scroll).
 */
export function goToHomeSection(navigate, pathname, id, { delayMs = 220 } = {}) {
  if (pathname !== '/') {
    navigate('/');
    window.setTimeout(() => scrollToSectionById(id), delayMs);
  } else {
    scrollToSectionById(id);
  }
}
